import { render, staticRenderFns } from "./managecarinfo.vue?vue&type=template&id=0f20a538&scoped=true"
import script from "./managecarinfo.vue?vue&type=script&lang=js"
export * from "./managecarinfo.vue?vue&type=script&lang=js"
import style0 from "./managecarinfo.vue?vue&type=style&index=0&id=0f20a538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f20a538",
  null
  
)

export default component.exports